import React from 'react';
import { ChildrenType, ITooltip, PlacesType, Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import styles from './tooltip.module.css';

interface ToolTipProps {
	anchorId: string;
	content?: string;
	className?: keyof typeof styles;
	place?: PlacesType | undefined;
	children?: ChildrenType;
	clickable?: boolean;
	openOnClick?: boolean;
	fixed?: boolean;
	isOpen?: boolean;
	setIsOpen?: (value: boolean) => void;
	globalCloseEvents?: ITooltip['globalCloseEvents'];
	opacity?: number;
}

const ToolTip = ({
	anchorId,
	content,
	className = 'default',
	place,
	children,
	clickable,
	openOnClick,
	fixed = true,
	isOpen,
	setIsOpen,
	globalCloseEvents,
	opacity,
}: ToolTipProps) => {
	const tooltipClass = className ? styles[className] : undefined;

	return (
		<Tooltip
			openOnClick={openOnClick}
			clickable={clickable}
			place={place}
			anchorSelect={`#${anchorId}`}
			content={content}
			children={children}
			className={tooltipClass}
			style={fixed ? { position: 'fixed' } : undefined}
			isOpen={isOpen}
			setIsOpen={setIsOpen}
			globalCloseEvents={globalCloseEvents}
			opacity={opacity}
		/>
	);
};

export default ToolTip;
